








import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';

@Component({
  name: 'JobWorkerInterviewWorkerConfirmationStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	interview: JobWorkerInterviewDto;

	get pendingConfirmation() {
		return (!this.interview.workerConfirmedById && !this.interview.workerDeclinedById);
	}

	get confirmed() {
		if (this.interview.workerConfirmedById) {
			return true;
		}
		return false
	}

	get declined() {
		if (this.interview.workerDeclinedById) {
			return true;
		}
		return false
	}
}
